export const CHANGE_PASSWORD_COMPLETE = 'CHANGE_PASSWORD_COMPLETE';

export const CHANGE_PASSWORD_PENDING = 'CHANGE_PASSWORD_PENDING';

export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export type ChangePasswordReducerState = {
  passwordChangeIsCompleted: boolean;
  passwordChangeIsPending: boolean;
  passwordChangeIsError: null | boolean;
};

export type ChangePasswordActions =
  | { type: 'CHANGE_PASSWORD_COMPLETE' }
  | { type: 'CHANGE_PASSWORD_PENDING' }
  | { type: 'CHANGE_PASSWORD_ERROR'; error: unknown };
